export const table = {
  'tour-operator_reports-list': {
    path_name: 'tour-operator_report-edit',
    columns: [
      {
        name: 'review_status',
        isSortable: true,
      },
      {
        name: 'number',
        isSortable: true,
        // alignCenter: true
      },
      {
        name: 'name',
        isSortable: true,
      },
      {
        name: 'signed_at',
        type: 'date',
        isSortable: true,
      },
    ],
    tooltip: {
      approved: [
        {
          name: 'readonly',
          type_action: 'readonly',
          isRouting: true,
          handler: null,
        },
        {
          name: 'downloadPDF',
          isRouting: false,
          handler: 'downloadFile',
        },
      ],
      pending_review: [
        {
          name: 'readonly',
          type_action: 'readonly',
          isRouting: true,
          handler: null,
        },
        {
          name: 'downloadPDF',
          isRouting: false,
          handler: 'downloadFile',
        },
      ],
      needs_improvement: [
        {
          name: 'make_changes',
          type_action: 'edit',
          isRouting: true,
          handler: null,
        },
        {
          name: 'downloadPDF',
          isRouting: false,
          handler: 'downloadFile',
        },
      ],
      waiting_for_submission: [
        {
          name: 'edit',
          type_action: 'edit',
          isRouting: true,
          handler: null,
        },
        {
          name: 'downloadPDF',
          isRouting: false,
          handler: 'downloadFile',
        },
        {
          name: 'delete',
          isRouting: false,
          handler: 'deleteReportsDraft',
        },
      ],
    },
    actions: {
      approved: 'readonly',
      pending_review: 'readonly',
      waiting_for_submission: 'edit',
      needs_improvement: 'edit',
    },
  },
};
